import { IAssignment } from "./assignment.model";
import { LocationModel } from "./location.model";
import { LocationAssignment } from "./locationAssignment.model";
import { Ppe } from "./ppe.model";
import { PpeAssignment } from "./ppeAssignment.model";

export class TaskAssignment implements IAssignment{
  id: string;
  startDate: number;
  endDate: number;
  taskId: string;
  sensorAssignmentId: string;
  timeOnTask: number;
  isFinished: boolean;
  locationAssignments: LocationAssignment[];
  // Read-only: PPE is assigned per sample, and the API no longer stores it on a task.
  ppeAssignments?: PpeAssignment[];
  startTime: string;
  endTime: string;
}

export class TaskAssignmentExposureContribution {
  taskId: string;
  timeOnShift: number;
  massContribution: number;
  taskName: string;
  taskGroupName: string;
  taskAssignments: TaskAssignment[];
  locations: LocationModel[];
  ppes: Ppe[];
  visible?: boolean;
}

export interface TaskTimeRange{
  id: string;
  startDate: number;
  endDate: number;
}